/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {EmailNotifications} from './EmailNotifications';
import {diplomatObjectSchema} from './diplomat-object';

export const ITSupportEmailSettings = diplomatObjectSchema.shape({
   notifications: EmailNotifications,
});
export type IITSupportEmailSettings = yup.InferType<typeof ITSupportEmailSettings>;
